import React from "react";
import GlobalStyles, { CommonClasses } from "../../global/GlobalStyles";
import { SiteName } from "../../global/SiteName";
import logo from "../../logo.png";
import {
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      className={`w-full bg-primary text-light dark:text-dark text-sm py-12 ${CommonClasses.transition}`}
    >
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="flex flex-col items-center md:items-start">
            <Link
              className={`${GlobalStyles.navbarBrand} bg-light dark:bg-dark w-full flex justify-center ${CommonClasses.transition} ${CommonClasses.rounded} mb-2`}
              to="/"
            >
              <img src={logo} alt="logo" className={GlobalStyles.navbarLogo} />
              <span className={GlobalStyles.navbarLogoText}>{SiteName}</span>
            </Link>
            <p className={`${GlobalStyles.text} text-center mb-4`}>
              Delivering excellence in logistics and supply chain solutions.
            </p>
            <div className=" w-full justify-center flex gap-4">
              <a
                href="/"
                className={`${CommonClasses.transition} hover:text-secondary`}
              >
                <FaFacebook className="text-xl" />
              </a>
              <a
                href="/"
                className={`${CommonClasses.transition} hover:text-secondary`}
              >
                <FaTwitter className="text-xl" />
              </a>
              <a
                href="/"
                className={`${CommonClasses.transition} hover:text-secondary`}
              >
                <FaLinkedin className="text-xl" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className={`${GlobalStyles.serviceTitle} mb-4`}>Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className={`${GlobalStyles.text} ${CommonClasses.transition} hover:text-secondary`}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about-us"
                  className={`${GlobalStyles.text} ${CommonClasses.transition} hover:text-secondary`}
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/track"
                  className={`${GlobalStyles.text} ${CommonClasses.transition} hover:text-secondary`}
                >
                  Track Shipment
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className={`${GlobalStyles.text} ${CommonClasses.transition} hover:text-secondary`}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className={`${GlobalStyles.serviceTitle} mb-4`}>Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <FaMapMarkerAlt className="text-secondary" />
                <span className={`${GlobalStyles.text}`}>
                  123 Logistics St, City
                </span>
              </div>
              <div className="flex items-center gap-2">
                <FaPhone className="text-secondary" />
                <span className={`${GlobalStyles.text}`}>(123) 456-7890</span>
              </div>
              <div className="flex items-center gap-2">
                <FaEnvelope className="text-secondary" />
                <span className={`${GlobalStyles.text}`}>
                  support@summithaullogistics.org
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div
          className={`border-t border-light/20 mt-8 pt-8 text-center ${GlobalStyles.text}`}
        >
          <p>
            &copy; {new Date().getFullYear()} {SiteName}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
